<template>
    <div id="container-carousel" class="h-full relative p-banner-desk max-md:p-banner-mobile">
        <div v-for="banner, index in config" :class="[img == index ? ['active'] : ['inactive']]" class="h-full absolute left-0 top-0 w-full transition-opacity duration-145 ease-in-out">
            <img class="object-cover h-full w-full" :src="banner" :alt="'IMAGEN PROGRAMA ' + index" loading="lazy"/>
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { generalStore } from '@/stores';

const store = generalStore();

const props = defineProps([
    'banners'
])

var date = new Date(Date.now());
var config = ref([]);
var intervalID = ref()

var img = ref(0);

/**
 * Function used to change image in the slide
 */
const slide = () => {
    intervalID.value = setInterval(() => {
        img.value++;
        if(config.value[img.value] == null){
            img.value++;
        }
        if (img.value >= config.value.length) {
            img.value = 0;
        }
    }, 6500)
};

slide();

watchEffect(() => {
    if(props.banners){
        config.value = store.isMovil ? props.banners['banners-mobile'][date.getMonth()] : props.banners['banners-desktop'][date.getMonth()]
        if(config.value == undefined){
            config.value = [];
            store.isMovil ? config.value.push(props.banners['banners-mobile']['default']) : config.value.push(props.banners['banners-desktop']['default'])
        }
    }
})
</script>